// src/api/productData.js
// 模拟接口返回的商品数据（结构与 Mock.js 完全一致，无依赖）
export const getProductList = () => {
  // 直接返回模拟的接口响应数据
  return {
    "msg": "操作成功",
    "code": 200,
    "data": {
      "sectionList": [
        // 1. 顶部海报模块（对应页面顶部图片）
        {
          "sectionType": "POSTER_CYCLE",
          "posterList": [
            {
              "img": "https://youke1.picui.cn/s1/2025/08/26/68adbbbc40575.png",
              "alt": "原鲜冬虫夏草"
            }
          ]
        },
        // 2. 商品分类列表模块（核心数据，对应页面 goodList）
        {
          "sectionType": "PRODUCT_CLASS_LIST",
          "productClassList": [
            // 分类1：特级冻干冬虫夏草28根（type:1，4600条/公斤）
            {
              "productClass": {
                "name": "金标系列",
                "desc": "（产品级别：4600+条/公斤）",
                "tips": "特级冻干冬虫夏草系列",
                "icon": "https://youke1.picui.cn/s1/2025/08/27/68af09a2705b2.png", // 特级标识
                "type": "4",
                "showSubItems": true // 默认展开
              },
              "productList": [ // 二级商品列表（对应原 subGoods）
                {
                  "title": "金标(46006)28根",
                  "tips": "（产品级别：4600+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=969711232918&pisk=gJtZo861YcnNnnPIfBI4LFJLCOIOvil7jn1fnKvcC1fG1nO2ntXgjsXcIWXhB6ZjBGgA0I5eM1_1j1w2gKCLldMTfB1D6BCfon1X0RKeaoZs6Vp00ismNbiSVdp1DicWny3CN5BVnrmbm1qhXtwm-5JSVdpODRPmFem73uD7nq4ciIjh-TBGmtfGnvShetS0jZqg-WfdnijcsPvnxO6bjrq0jvohUOPGINbctwX13SjcmIvnLtChIijDipDFHvkkmhZF_NDeLSDEQfzP8_vGToqzeO7gRpUbquXdIN-DI6uIRHWN7_bmSCNvjB9DfhQKa7jvdUR2oI37JGJDSGXWBcrFqdYB09tjhr5M6HJHxwy7Vi8M_EbJ80URSZ5w-hbUnovd0FbkuClaW1Y6TaBh--oRdQ1HBhYEHWvMN1SGKwioUpbDRhQJfXqNqUp1fEAxPyIwnFjF4WFAKm0XDFP0uNXdL_MELyG7PeuUjUC3krQFp95SUYzYkN0OL_MFsrUA-J6FNAwR.&spm=a21xtw.29178619.0.0",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b2e47d58589.png",
                  "money": "999.00"
                },
                {
                  "title": "金标(46006)36根",
                  "tips": "（产品级别：4600+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=968432626202&pisk=gUd-u6wWymmkjCZzyHDmt7PDkB3DyxYPc38_tMjudnKvR3slxgNCcE_OWuNQOe_C9ntnzgYI4Hddce-hq6f7dXKM70Pkt_YBH381EHLEzwsBAHIHExcMzU5FOcjKsfYrH8fLgHB5Ao_XuNsQVxX5NC6_mcmisfD7l6n-jHbf5_JfWN1CP9sQlqQd8J1CFa6jkw_3VJNWAEgA0wz5A8w5hi_OPu1QFwaflw_3dw_CdE6f0wCCAH1IkssVR6sBA6MeUYI0PZFpFQa6fMgg35F9MaBRvWjb9iOTsts1aiNIfIQJ_GT5DWNCXjgEDELo258caEtOS3cbwhLwgnQXfXnATnJBAwKj_kfyI3RNHEk_GUCR0O_6G2N1xQpD5iCTRbTAwgB6ZOhKJhTvRdXviVGNw_sWK_83W0Yvw3YyMe4Qh_CkHOdR1fr5xKY99wdEYjK97I-AlhGKVg89sCBc_ljO-8gxkJyFFZPB8eWp8WUH1ZIiP4wUL9_VkG0AeJyFF0bAj4L7LJW2-&spm=a21xtw.29178619.0.0",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b2e47cb5328.png",
                  "money": "1299.00"
                }
              ]
            },
            // 分类2：特级冻干冬虫夏草36根（type:1，4600条/公斤）
            {
              "productClass": {
                "name": "银标系列",
                "desc": "（产品级别：2400+条/公斤）",
                "tips": "特级冻干冬虫夏草系列",
                "icon": "https://youke1.picui.cn/s1/2025/08/27/68af09a2705b2.png",
                "type": "1",
                "showSubItems": false
              },
              "productList": [
                {
                  "title": "银标(2400+)30克",
                  "tips": "（产品级别：2400+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=965511817021&spm=a21xtw.29178619.0.0&pisk=gcunuJTZRDrBO0QCxQ4Bvrq6vKKtAya7NYQ8ezeybRy1JYULyR5aa7SPYwyP_ccjEJdWAyngEAkgLw38JbkiivmdpewdZYc7BYQ-94m1rjGSJBaJOyGQPzJvHEUoOXa7p1OTC44Z_SNeywSUTyaNNCX3DELxOX1LTIhwk4QV0lPO4akzYlPaORPP87kz7GP4QwPP87Wws7wazwSUzF8aZ7sPUwky7GPYiWPFzkWZ_7Vuz7kzzCcaC74zUYzysfkbg6yjz0uwUlW3oJcvK2F3x-lULXhn7pEcAfeiHx0atf2qTb_PzVV3xV7Ml20av0lbc23erNaKiczaMXThSrlUivet3E7g7fhZeoi6FZEsI4qr8k1y_RunI2aEp37mnyDu02rGaahmTJ4g_qRRcR3gpYu3bIQ02PuY0yo9fpE8-SDrRvflzxltM2ZsrKXaFDFb7ShB-N4qT7SrRGS2ne_7_Q3NVgZU152xzo2kiBSlccAMsiI7Y5N0HCAGVnqU15Y6sCjb2kP_9v1..",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b2e5575f3d1.png",
                  "money": "4140.00"
                },
                {
                  "title": "银标(2400+)60克",
                  "tips": "（产品级别：2400+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=964343771520&pisk=gn8SoWNRV827sixOVwl4cj8MJNbCFjuNeW1psBUz9aQRpW9v9zedewEYk1CTpMBEqpsBLKjpzaRyh9pkn9WRT3zQpndHLT7e9W1p3aIH49WPdwOHCjkZ7VRkZwjKQAuwvV7uvNfL2zeFH-ChR_BaMz9WZwbKQSzKbVOkEfZ9ZWCdMj1FTyeppMBYDtfQeJpdeieA11bdpppdHqChN7Cde6FYHtf7vyBRpteA66ZR9wppMj1hH9Qd2pdxG6XApx67l6m56QGT5aCdGR09TtaLJE1xKOAS0rfpz_G5IQ6jBALXIg69wtaKe7nnv96DWxoXinKJUsvI5x_HnHpdOKexLgApcK1WUAwhLUAyRTRS2xdfoT9RVnGTqsO2PBtdcb3JGa65bepY9u_WvLYCq3NnsIQJnhXG2mDcGU8NAOjbHYd2GTI6ALk0JT-6MKswu-zN-Kxpp69YFgzQ7O_K6kNfjy1fQjGbxk26UWYOcW4XDgCcwOljG8qh2sfXBjGbxaSRi_wiGjw-3&spm=a21xtw.29178619.0.0",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b2e55768c50.png",
                  "money": "8280.00"
                },
                {
                  "title": "银标(2400+)100克",
                  "tips": "（产品级别：2400+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=969747984936&spm=a21xtw.29178619.0.0&pisk=gTDEoRqQQppUdH_6dVePbXoOAkeLw88fKYa7q0muAy43RYgrquqhKzquxNqgvP6WvJO8U4zZyyNQKysrz0UONDtddVaoJVU7ZYaSUMHZuT6BJBnlU8wklE9XhDnQe8Yjq1d_lwEbVkv5E8qgpuskswoXhDnLeM7kcfvf4txq9Qfur42gsoE3Eu43qhygvk2lK7XhsN4Tq82u-6mMIkZ5K_XlKhJg0k7hE9fhjlqQ2_2ut4mMbuUgx82orcxa2x_-Ev6a8WxZbaxwY6v3Nrm37TXVDlPhi255K9juvW40sPWk1ArUTrmn3m5OnlDsQSN1VIeiDfg3b-J1t-mZZqlmyI1TL0cny5upW1zssvnurWSlhcoqxj2iF3jY_Vqzi8VNqTmapzuqK-vc7lhiAbDK8gWuvvMbarFwqTF7IxNmi2SJDc23q4FxFEBL-0mxHjw2C62mbb0qagzFylvkNYhFr_P3XlzXbh56lsGw_9cYS_C8_lEaln-Vw_FnblzXbSfRw5j_brtCD",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b2e557881d8.png",
                  "money": "13500.00"
                }
              ]
            },
            // 分类3：一级冻干冬虫夏草60根（type:2，3200条/公斤）
            {
              "productClass": {
                "name": "银标系列",
                "desc": "（产品级别：3200+条/公斤）",
                "icon": "https://youke1.picui.cn/s1/2025/08/27/68af099069888.png", // 一级标识
                "type": "2",
                "showSubItems": false
              },
              "productList": [
                {
                  "title": "银标(3200+)10克",
                  "tips": "（产品级别：3200+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=965499609638&pisk=g_vIo1qdOy4BAdRAOToa1cJDetX5AckVJusJm3eU29BdyuT92JURJTFTBiIYy_QrtU1WzFfJL9-e5aLHSa7d4By7yCKkzwWy2usJ79CkTa7FPTtklcuq3x-HxTf-uqk2wxW3wt4LwWUPXOIfFMQ4XJTBxTX-uly-gxtH-mNAYuIRXcsP48UJy_QT6Nj7vzLRJ1UOciXRyULRWAIlAkIRJgETWNjQwWQ89AFOqMN8p8LJXcslWaBR9UKtfgbOyxZ8CgcCDHiYh9IRfREpDNw8edstraKIi7b9nMNllH7skqp6o6_vvNw-Jkhowa_MHVl6jCdp8GYShV6kSQLRVFUtz6xJ1FsB8qalzpxeFw-I9VK1IwTdOCiYtGtwd3OR1DHpf9_CgLLT2W6Bwev5tBZomhBpSIbc9f0GfpJVNZf_W2KwfwCXNeugewRXXF12QPyVEFAJygTTRg7Q3Z6-D7Z1i8s1uci_Z74X8uvA1u2666IGvZosfyVl9Gj6kci_Z95djMamfcaK7&spm=a21xtw.29178619.0.0",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b31430d75a8.png",
                  "money": "1280.00"
                },
                {
                  "title": "银标(3200+)20克",
                  "tips": "（产品级别：3200+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=966122016648&pisk=gqUiur_U5los4sL6js01X4mCXTIKXVgjG-LxHqHVYvkBW-3tkvREgj-2bFk2TkV7nACffVEnnJynQFUxWSy3ZRq9BNM9i-Vjp-LY6rqBo7NbW1gA1VNslqWRea3015gjBB1Kdr0EYbcPkEoZ3VgeG6vi2aQ815Ot__FFyrLy45lp0EyqbDlE1vl27jyqYWlrLFl27jJFtjMEuF-Zuw7Eijt23FyV8Hloijlquc-eYbGZufyqu6VEdj0q3-uVtWkbuCk7uozF3DJirAccbrlijYPZQ5FQ8Q0efSM3DozEsWDz_ST2uycijy8hPP4EXoPSVPUNoegTZkuEw5_M-4PZZRHLUa8n8WFUH0ZChUnQKrm47cOVTvzgKPgaBi8uEV2m4PoHgEFu_A0nTz5vVvUnB-ziY_LoD2z-4VrdAOnxSb245RADu8PLwPiQoTvEhlhS8bF1Se0z_jSzFH-PENTjTsUecniZOXD8u0DcZ1-DVkfht3KjbXGoe6fHcgmZOXbCt6xSDclI6R1..&spm=a21xtw.29178619.0.0",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b314313f8da.png",
                  "money": "2560.00"
                }
              ]
            },
            // 分类4：一级冻干冬虫夏草10克（type:2，3200条/公斤）
            {
              "productClass": {
                "name": "银标系列",
                "desc": "（产品级别：3600+条/公斤）",
                "icon": "https://youke1.picui.cn/s1/2025/08/27/68af099069888.png",
                "type": "3",
                "showSubItems": false
              },
              "productList": [
                {
                  "title": "银标(3600+)3克",
                  "tips": "（产品级别：3600+条/公斤）",
                  "taobaoUrl": "https://detail.tmall.com/item.htm?id=964794946222&spm=a21xtw.29178619.0.0&pisk=gPtioNmefF71tBq_SxjsWgbIWb3d6GsfhIEAMiCq865QXIIOD6yF3tz47l54LevWi1Hj5GLhiBRh_lKAXKRHECYT6c1TnIvf9IEvBnYQmL9XXAsxCG91cil-w0IDCdsf6JMdOhqF8tvU0OWqJMSZpa_-w0nJCVW1DplJD9zzG9X80i7Nu9yFOtEauI7VYy5ChtPN3lkHL61UbRS47D7F3TF4_Iza89WPIoyNgt7F8tfFgiS2gpkhH65V0iR2Lx90Q_t2uHlV85jls_l2cObGad5wBptUsMa6U6xyqHWMK_Jwhor2xObMYkmWjH79uL_WXho0AGpk8MWJCcqh4dWk66dr4kjeppRAPeGb2wOHmZ-N5-kFThAHfGRtuuAljIbybw24DLvNsMXe4xU59Hf9ghbEeubAY3QPbe3I6ZIGEI-6s-q2appJfwtmZW5XWTsFedigxgJN3g878zlofo6EHHzblNWCK_KVrsDoQr4W-vD3yr_NdTf-Kv4jrNWCKDMnKz_A79691",
                  "goodsImg": "https://youke1.picui.cn/s1/2025/08/30/68b3143fd21a2.png",
                  "money": "354.00"
                },


              ]
            }
          ]
        }
      ]
    }
  };
};

// 可选：模拟异步请求（模仿真实接口延迟，如需要同步数据可忽略）
export const getProductListAsync = () => {
  return new Promise((resolve) => {
    // 延迟 300ms 返回数据（模拟网络延迟）
    setTimeout(() => {
      resolve(getProductList()); // 调用同步数据函数
    }, 300);
  });
};